module.exports = __webpack_public_path__ + "img/106.43cddfeb.jpg";